module.exports = __webpack_public_path__ + "img/badge_esp_adren.f06d3982.jpg";